'use client';
import { useEffect, useRef, useState } from 'react';
import { useExperience } from './Experience';

export function Message({ as: Tag = 'div', answer = false, className = '', children, ...props }) {
  const ref = useRef(null);
  const [phase, setPhase] = useState('ready');
  const { t } = useExperience();
  useEffect(() => {
    const node = ref.current;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches || !window.IntersectionObserver) return;
    let timer;
    const finish = () => { clearTimeout(timer); setPhase('complete'); };
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      setPhase(answer ? 'typing' : 'enter');
      timer = setTimeout(finish, answer ? 600 : 350);
    }, { threshold: 0.15, rootMargin: '-72px 0px -30px 0px' });
    observer.observe(node);
    const visibility = () => { if (document.hidden) finish(); };
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', finish);
    return () => { observer.disconnect(); clearTimeout(timer); document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', finish); };
  }, [answer]);
  return <Tag {...props} ref={ref} className={`${className} message-reveal`} data-phase={phase}>
    {children}
    {phase === 'typing' && <span className="message-typing" aria-hidden="true"><span className="typing-dots"><i/><i/><i/></span>{t('Palmate yazıyor')}</span>}
  </Tag>;
}
